// extracted by mini-css-extract-plugin
var _1 = "popover__FZzdB";
var _2 = "search__RDVP1";
export { _1 as "popover", _2 as "search" }
